import React from 'react'
import _ from 'lodash'
import { Card, Col, Row } from 'antd'
import { MaterialItem } from '../../styles/shared.style'
import PropTypes from 'prop-types'

const MaterialList = (props) => {
  const { materials, renderItemActive, onClickItem } = props
  return (
    <Card style={{ marginTop: 10, height: 450, overflowY: 'scroll' }}>
      {!_.isEmpty(materials) &&
        materials.map((item, index) => {
          return (
            <Row key={index}>
              <Row style={{ width: '100%' }}>
                <span style={{ color: 'green', fontSize: 18 }}>
                  {item.categoryName}
                </span>
              </Row>
              <Row type="flex" gutter={8}>
                {item.materialList.map((material, idx) => {
                  return (
                    <Col key={idx}>
                      <MaterialItem
                        active={renderItemActive(material)}
                        onClick={() => onClickItem(material)}>
                        {material.name}
                      </MaterialItem>
                    </Col>
                  )
                })}
              </Row>
            </Row>
          )
        })}
    </Card>
  )
}

MaterialList.propTypes = {
  materials: PropTypes.array.isRequired,
  renderItemActive: PropTypes.func.isRequired,
  onClickItem: PropTypes.func.isRequired
}

export default MaterialList



// WEBPACK FOOTER //
// ./src/components/MaterialList/index.js